export default {
  'backrest_adjustment30': {
    cs: 'Zvednutí zádového dílu',
    en: 'Backrest Adjustment',
    track: 'backrest30',
    conflicting: []
  },
  'backrest_adjustment60': {
    cs: 'Zvednutí zádového dílu',
    en: 'Backrest Adjustment',
    track: 'backrest60',
    conflicting: []
  },
  'backrest_adjustment90': {
    cs: 'Zvednutí zádového dílu',
    en: 'Backrest Adjustment',
    track: 'backrest90',
    conflicting: []
  },
  'backrest_adjustment30rev': {
    cs: 'Sklopeni zádového dílu',
    en: 'Backrest Adjustment',
    track: 'backrest30rev',
    conflicting: []
  },
  'backrest_adjustment60rev': {
    cs: 'Sklopeni zádového dílu',
    en: 'Backrest Adjustment',
    track: 'backrest60rev',
    conflicting: []
  },
  'backrest_adjustment90rev': {
    cs: 'Sklopeni zádového dílu',
    en: 'Backrest Adjustment',
    track: 'backrest90rev',
    conflicting: []
  },
  'bed_height_adjustment_up': {
    cs: 'Zvedání ložné plochy',
    en: 'Bed Height Adjustment Up',
    track: 'height_adjustment_up',
    conflicting: [],
    conditional: []
  },
  'bed_height_adjustment_down': {
    cs: 'Klesání ložné plochy',
    en: 'Bed Height Adjustment Down',
    track: 'height_adjustment_down',
    conflicting: [],
    conditional: []
  },
  'trendelenburg': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'trendelenburg',
    opposite: 'reverse_trendelenburg',
    conflicting: [],
    conditional: []
  },
  'trendelenburg_to_max': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'trendelenburg_to_max',
    conflicting: [],
    overrides: []
  },
  'trendelenburg_to_min': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'trendelenburg_to_min',
    conflicting: [],
    overrides: [],
  },
  'reverse_trendelenburg': {
    cs: 'Reverzní Trendelenburg',
    en: 'Reverse Trendelenburg',
    track: 'reversetrendelenburg',
    opposite: 'trendelenburg',
    conflicting: [],
    conditional: []
  },
  'reversetrendelenburg_to_max': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'reversetrendelenburg_to_max',
    conflicting: [],
    overrides: []
  },
  'reversetrendelenburg_to_min': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'reversetrendelenburg_to_min',
    conflicting: [],
    overrides: []
  },
  'leg_rest_adjustment01': {
    cs: 'Zvedání nohou',
    en: 'Legrest adjustment',
    track: 'leg_rest_adjustment01',
    conflicting: [],
    conditional: []
  },
  'leg_rest_adjustment01rev': {
    cs: 'Složení nohou',
    en: 'Legrest adjustment',
    track: 'leg_rest_adjustment01rev',
    conflicting: [],
    conditional: []
  },
  'leg_rest_adjustment02': {
    cs: 'Zvedání nohou',
    en: 'Legrest adjustment',
    track: 'leg_rest_adjustment02',
    conflicting: [],
    conditional: []
  },
  'leg_rest_adjustment02rev': {
    cs: 'Složení nohou',
    en: 'Legrest adjustment',
    track: 'leg_rest_adjustment02rev',
    conflicting: [],
    conditional: []
  },
  'calf_rest_adjustment': {
    cs: 'Zvedání lýtek',
    en: 'Calfrest adjustment',
    track: 'calf_rest_adjustment',
    conflicting: [],
    conditional: []
  },
  'calf_rest_adjustment01': {
    cs: 'Zvedání lýtek',
    en: 'Calfrest adjustment',
    track: 'calf_rest_adjustment01',
    conflicting: [],
    conditional: []
  },
  'calf_rest_adjustment_rev': {
    cs: 'Složení lýtek',
    en: 'Calfrest adjustment',
    track: 'calf_rest_adjustment_rev',
    conflicting: [],
    conditional: []
  },
  'calf_rest_adjustment01_rev': {
    cs: 'Složení lýtek',
    en: 'Calfrest adjustment',
    track: 'calf_rest_adjustment01_rev',
    conflicting: [],
    conditional: []
  },
  'cpr': {
    cs: 'CPR pozice',
    en: 'CPR Position',
    track: 'height_adjustment_down',
    conflicting: [],
    conditional: [],
    reversable: false
  },
  'folding_of_siderails_up': {
    cs: 'Postranice nahoru',
    en: 'Siderails up',
    track: 'folding_of_siderails_up',
    conflicting: []
  },
  'folding_of_siderails_down': {
    cs: 'Postranice dolů',
    en: 'Folding of Siderails',
    track: 'folding_of_siderails_down',
    conflicting: []
  },
  'pushhandles_up': {
    cs: 'Madla nahoru',
    en: 'Push handles up',
    track: 'pushhandles_up',
    conflicting: []
  },
  'pushhandles_down': {
    cs: 'Madla dolů',
    en: 'Push handles down',
    track: 'pushhandles_down',
    conflicting: []
  },
  'poles_rotation_up': {
    cs: 'Tyče nahoru',
    en: 'Poles rotation up',
    track: 'poles_rotation_up',
    conflicting: []
  },
  'poles_move_up': {
    cs: 'Tyče vysunutí',
    en: 'Poles move up',
    track: 'poles_move_up',
    conflicting: []
  },
  'poles_move_down': {
    cs: 'Tyče zasunutí',
    en: 'Poles move down',
    track: 'poles_move_down',
    conflicting: []
  },
  'poles_rotation_down': {
    cs: 'Tyče dolů',
    en: 'Poles rotation down',
    track: 'poles_rotation_down',
    conflicting: []
  },
  'idrive': {
    cs: 'i-Drive',
    en: 'i-Drive',
    track: 'idrive',
    conflicting: []
  },
  'idrive_rev': {
    cs: 'FlexiDrive',
    en: 'FlexiDrive',
    track: 'idrive_rev',
    conflicting: []
  },
}
